
import { Component, Inject, Input, NgZone } from '@angular/core';

@Component({
  templateUrl: './workers.component.html',
})
export class SystemHealthWorkersComponent {
  constructor() {
  }
}
